module.exports = __webpack_public_path__ + "img/namad.f3deb2bb.svg";